import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fillOpacity: ".3",
  d: "M4.41 22H20c1.1 0 2-.9 2-2V4.41c0-.89-1.08-1.34-1.71-.71L3.71 20.29c-.63.63-.19 1.71.7 1.71z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 12l-8.29 8.29c-.63.63-.19 1.71.7 1.71H12V12z"
})), 'SignalCellular1BarRounded');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SignalCellular1BarRounded.js
// module id = 6140
// module chunks = 2